export const genephenotypeassociationsColumns = [
  { field: "phenotype", flex: 1, minWidth: 150, headerName: "Phenotype" },
  {
    field: "z-score",
    headerName: "Z-score",
    valueGetter: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["z-score"] ?? param.row?.z_score;
      }
      const num = typeof value === "number" ? value : parseFloat(value);
      if (isNaN(num)) return "";
      return num.toFixed(2);
    },
  },
  {
    field: "known",
    flex: 0.3,
    headerName: "in Kg",
    sortable: false,
    renderCell: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["known"] ?? param.row?.known;
      }
      return <span>{value ? "✓" : "✗"}</span>;
    },
  },
];
export const genepathwayassociationsColumns = [
  { field: "pathway", flex: 1, minWidth: 150, headerName: "Pathway" },
  {
    field: "z-score",
    headerName: "Z-score",
    valueGetter: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["z-score"] ?? param.row?.z_score;
      }
      const num = typeof value === "number" ? value : parseFloat(value);
      if (isNaN(num)) return "";
      return num.toFixed(2);
    },
  },
  {
    field: "known",
    flex: 0.3,
    headerName: "in Kg",
    sortable: false,
    renderCell: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["known"] ?? param.row?.known;
      }
      return <span>{value ? "✓" : "✗"}</span>;
    },
  },
];
export const genegeneinteractionsColumns = [
  { field: "neighbor", flex: 1, minWidth: 150, headerName: "Neighbor" },
  {
    field: "z-score",
    headerName: "Z-score",
    valueGetter: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["z-score"] ?? param.row?.z_score;
      }
      const num = typeof value === "number" ? value : parseFloat(value);
      if (isNaN(num)) return "";
      return num.toFixed(2);
    },
  },
  {
    field: "known",
    flex: 0.3,
    headerName: "in Kg",
    sortable: false,
    renderCell: (param: any) => {
      let value = param;
      if (typeof param === "object" && param !== null) {
        value = param.value ?? param.row?.["known"] ?? param.row?.known;
      }
      return <span>{value ? "✓" : "✗"}</span>;
    },
  },
];
export const phenotypeHeaders = [
  { label: "Phenotype", key: "phenotype" },
  { label: "Z score", key: "z_score" },
  { label: "In Kg", key: "in_kg" },
];
export const pathwayHeaders = [
  { label: "Pathway", key: "pathway" },
  { label: "Z score", key: "z_score" },
  { label: "In Kg", key: "in_kg" },
];
export const interactionHeaders = [
  { label: "Neighbor", key: "neighbor" },
  { label: "Z score", key: "z_score" },
  { label: "In Kg", key: "in_kg" },
];
